import { z } from "zod/v4";

import {
  OfferProductDtoDescriptions,
  OfferProductVariantDtoDescriptions,
} from "../descriptions/offer-product-dto.describe";
import { assertDescriptions } from "../descriptions/types";
import { castToNumber } from "../utils";
// import { OfferProductInclusionTypeList } from "./product-variants";

export const OfferProductInclusionTypeList = ["include", "exclude"] as const;

export type OfferProductInclusionType =
  (typeof OfferProductInclusionTypeList)[number];

// Which BXGY product set an entry belongs to. Every other offer only has "buy".
export const OfferProductSetList = ["buy", "get"] as const;

export type OfferProductSet = (typeof OfferProductSetList)[number];

export const OfferProductVariantDtoSchema = z.object({
  uuid: z.uuid().optional().describe(OfferProductVariantDtoDescriptions.uuid),
  id: z.string().describe(OfferProductVariantDtoDescriptions.id),
  title: z.string().describe(OfferProductVariantDtoDescriptions.title),
  price: castToNumber.describe(OfferProductVariantDtoDescriptions.price),
  compareAtPrice: castToNumber
    .nullish()
    .describe(OfferProductVariantDtoDescriptions.compareAtPrice),
  inclusionType: z
    .enum(OfferProductInclusionTypeList)
    .default("include")
    .describe(OfferProductVariantDtoDescriptions.inclusionType),
});

export type OfferProductVariantDto = z.infer<
  typeof OfferProductVariantDtoSchema
>;

export const OfferProductDtoSchema = z.object({
  id: z.string().describe(OfferProductDtoDescriptions.id),
  title: z.string().describe(OfferProductDtoDescriptions.title),
  image: z.string().nullish().describe(OfferProductDtoDescriptions.image),
  variants: OfferProductVariantDtoSchema.array().describe(
    OfferProductDtoDescriptions.variants
  ),
  variationId: z.uuid().describe(OfferProductDtoDescriptions.variationId),
  offerId: z.uuid().nullable().describe(OfferProductDtoDescriptions.offerId),
  set: z
    .enum(OfferProductSetList)
    .default("buy")
    .describe(OfferProductDtoDescriptions.set),
});

export type OfferProductDto = z.infer<typeof OfferProductDtoSchema>;

// Compile-time checks: description objects must cover all schema keys
assertDescriptions<
  typeof OfferProductVariantDtoDescriptions,
  OfferProductVariantDto
>();
assertDescriptions<typeof OfferProductDtoDescriptions, OfferProductDto>();
